import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Badge, Button, Form } from 'react-bootstrap';
import { FaUserGraduate, FaBriefcase, FaEnvelope, FaMapMarkerAlt, FaArrowLeft, FaCheckCircle, FaLinkedin, FaFacebook, FaDirections } from 'react-icons/fa';
import './AlumniDetails.css';

const OSH_TU_COORDINATES = { lat: 40.48740, lng: 72.83214, address: "г. Ош, ул. Исанова, 81" };
const mapUrl = "https://www.google.com/maps/search/?api=1&query=ОшТУ+Ош+ул+Исанова+81&query_place_id=ChIJrZKil0CuvTgRn4cKJtb7Z4U";

const AlumniDetails = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const alumni = state?.alumni;
    const [showContactForm, setShowContactForm] = useState(false);

    if (!alumni) return <Container className="py-5 text-center"><h4>Данные не найдены</h4></Container>;

    const mainColor = '#006186';

    // Функция для получения фото
    const getImageUrl = () => {
        if (alumni.image_url) {
            // Если это Data URL (начинается с data:image)
            if (alumni.image_url.startsWith('data:image')) {
                return alumni.image_url;
            }
            // Если это относительный путь
            if (alumni.image_url.startsWith('/uploads')) {
                return `http://localhost:5000${alumni.image_url}`;
            }
            // Если это внешняя ссылка
            return alumni.image_url;
        }
        return null; // нет фото
    };

    const imageUrl = getImageUrl();

    return (
        <div className="alumni-details-page bg-light-subtle min-vh-100">
            {/* Навигация */}
            <div className="detail-header py-3 bg-white border-bottom sticky-top">
                <Container className="d-flex align-items-center">
                    <Button variant="link" onClick={() => navigate(-1)} className="text-dark p-0 me-3">
                        <FaArrowLeft />
                    </Button>
                    <h5 className="mb-0 fw-bold">Профиль выпускника</h5>
                </Container>
            </div>

            <Container className="py-5">
                <Row className="g-4">
                    {/* Левая колонка: Основной профиль */}
                    <Col lg={4}>
                        <Card className="border-0 shadow-sm text-center p-4 rounded-4 profile-main-card">
                            <div className="avatar-section mb-3">
                                {imageUrl ? (
                                    <img 
                                        src={imageUrl} 
                                        alt={alumni.fio} 
                                        className="profile-avatar shadow"
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.style.display = 'none';
                                            e.target.parentNode.innerHTML = `
                                                <div class="profile-avatar-placeholder shadow" style="width:120px; height:120px; border-radius:50%; background: linear-gradient(145deg, #006186, #00a1d9); display:flex; align-items:center; justify-content:center; margin:0 auto;">
                                                    <svg stroke="currentColor" fill="white" stroke-width="0" viewBox="0 0 448 512" height="50" width="50" xmlns="http://www.w3.org/2000/svg"><path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path></svg>
                                                </div>
                                            `;
                                        }}
                                    />
                                ) : (
                                    <div className="profile-avatar-placeholder shadow" style={{
                                        width: '120px',
                                        height: '120px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(145deg, #006186, #00a1d9)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto'
                                    }}>
                                        <FaUserGraduate size={50} color="#fff" />
                                    </div>
                                )}
                                {alumni.is_association_member && (
                                    <div className="verified-badge" title="Подтвержденный выпускник">
                                        <FaCheckCircle />
                                    </div>
                                )}
                            </div>
                            <h3 className="fw-bold mb-1">{alumni.fio}</h3>
                            <p className="text-muted small mb-3">{alumni.specialty}</p>

                            <div className="d-grid gap-2">
                                <Button
                                    style={{ backgroundColor: mainColor, border: 'none' }}
                                    className="rounded-pill py-2 fw-bold"
                                    onClick={() => setShowContactForm(!showContactForm)}
                                >
                                    Написать сообщение
                                </Button>
                                <div className="d-flex justify-content-center gap-3 mt-2 fs-4 text-muted">
                                    <FaLinkedin className="icon-hover" />
                                    <FaFacebook className="icon-hover" />
                                </div>
                            </div>

                            <hr className="my-4 opacity-50" />

                            <div className="text-start">
                                <h6 className="fw-bold small text-uppercase text-muted mb-3">Контакты</h6>
                                <div className="d-flex align-items-center mb-2 small">
                                    <FaEnvelope className="me-2 text-primary" /> {alumni.email || 'mail@example.com'}
                                </div>
                                <div className="d-flex align-items-center small">
                                    <FaMapMarkerAlt className="me-2 text-danger" /> {alumni.location?.address || 'Ош, Кыргызстан'}
                                </div>
                            </div>
                        </Card>
                    </Col>

                    {/* Правая колонка: Детали */}
                    <Col lg={8}>
                        {showContactForm && (
                            <Card className="border-0 shadow-sm mb-4 rounded-4 p-4 animate-fade-in">
                                <h5 className="fw-bold mb-3">Новое сообщение</h5>
                                <Form>
                                    <Form.Control as="textarea" rows={3} placeholder="Здравствуйте, я бы хотел..." className="border-0 bg-light mb-3" />
                                    <Button style={{ backgroundColor: mainColor }} className="border-0 px-4">Отправить</Button>
                                </Form>
                            </Card>
                        )}

                        <div className="bento-grid">
                            {/* Карточка образования */}
                            <Card className="border-0 shadow-sm rounded-4 p-4 mb-4">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="icon-box me-3"><FaUserGraduate color={mainColor} /></div>
                                    <h5 className="fw-bold mb-0">Образование</h5>
                                </div>
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <label className="text-muted small d-block">Направление</label>
                                        <span className="fw-semibold">{alumni.direction}</span>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <label className="text-muted small d-block">Год выпуска</label>
                                        <Badge bg="light" text="dark" className="fs-6 border">{alumni.graduation_year || '2024'}</Badge>
                                    </Col>
                                </Row>
                            </Card>

                            {/* Карточка карьеры */}
                            <Card className="border-0 shadow-sm rounded-4 p-4 mb-4">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="icon-box me-3 text-success"><FaBriefcase /></div>
                                    <h5 className="fw-bold mb-0">Текущая карьера</h5>
                                </div>
                                <div className="work-item p-3 bg-light rounded-3">
                                    <h6 className="fw-bold mb-1">{alumni.position || 'Software Engineer'}</h6>
                                    <p className="text-muted mb-0 small">{alumni.workplace || 'Google Inc.'}</p>
                                </div>
                            </Card>

                            {/* Карта (Минималистичная) */}
                            <Card className="border-0 shadow-sm rounded-4 overflow-hidden">
                                <div style={{ height: '300px', width: '100%' }}>
                                    <iframe
                                        title="OshTU Map"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3034.425987977457!2d72.83000871221714!3d40.48751555184857!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38bdbe4097a292ad%3A0x8567fbda260a879f!2z0J7RiNCi0KM!5e0!3m2!1sru!2skg!4v1715600000000!5m2!1sru!2skg"
                                        width="100%"
                                        height="100%"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                    ></iframe>
                                </div>
                                <Button
                                    variant="light"
                                    href={mapUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="rounded-0 border-top d-flex align-items-center justify-content-center gap-2 py-3 text-primary fw-bold"
                                >
                                    <FaDirections /> Открыть в навигаторе
                                </Button>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default AlumniDetails;